// src/firebase.js (COMPLETE REPLACEMENT)

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyA7GzgMWiNsyBY-cQOQ8aCo2oizn4768Ck",
  authDomain: "finalproject-35af4.firebaseapp.com",
  projectId: "finalproject-35af4",
  storageBucket: "finalproject-35af4.firebasestorage.app",
  messagingSenderId: "142018845673",
  appId: "1:142018845673:web:0dc7fba8450686741dc978",
  measurementId: "G-QLS4M3HSN4"
};

let app, auth, storage, db, messagingPromise;

const initializeFirebase = async () => {
  // ⭐ FIX: Ensure the firebase object is returned even if already initialized
  if (app) return { app, auth, storage, db, messagingPromise, firebase };

  try {
    if (!firebase.apps.length) {
      app = firebase.initializeApp(firebaseConfig);
    } else {
      app = firebase.app();
    }

    auth = firebase.auth();
    storage = firebase.storage();
    db = firebase.firestore();

    messagingPromise = new Promise((resolve) => {
      if (firebase.messaging.isSupported()) {
        console.log("Firebase Messaging is supported.");
        resolve(firebase.messaging());
      } else {
        console.log("Firebase Messaging is not supported in this browser.");
        resolve(null);
      }
    });

    console.log("Firebase services initialized successfully (compat mode).");
    
    // ⭐ FIX: Export the core 'firebase' object along with individual services.
    // This is needed in AuthContext to access persistence constants.
    return { app, auth, storage, db, messagingPromise, firebase };

  } catch (error) {
    console.error("Failed to initialize Firebase services:", error);
    throw error;
  }
};

export { initializeFirebase };